import React from "react";
import { useParams, useNavigate } from "react-router-dom";

import AiAvatarList from "./AiAvatarList";
import AiAvatarChat from "./AiAvatarChat";

const AiAvatarContainer = () => {
    const { modelId } = useParams();
    const navigate = useNavigate();

    const handleModelSelect = (selectedModelId) => {
        navigate(`chat/${selectedModelId}`);
    };

    const handleBack = () => {
        navigate("/voice-cloning");
    };

    return (
        <div>
            {!modelId ? (
                <AiAvatarList onModelSelect={handleModelSelect} />
            ) : (
                <AiAvatarChat modelId={modelId} onBack={handleBack} />
            )}
        </div>
    );
};

export default AiAvatarContainer;
